import {Component, OnInit, ViewChild} from '@angular/core';
import {MiniItem} from "../../../framework/model/core/items/miniitem";
import {ModelProvider} from "../../../framework/providers/modelProvider/ModelProvider";
import {IonContent, IonSearchbar} from "@ionic/angular";
import {Events} from "../../../framework/providers/events";
import {BusinessService} from "../../services/BusinessService";
import {AppDataService} from "../../services/AppDataService";
import {OrderService} from "../../services/OrderService";

@Component({
    selector: 'app-search',
    templateUrl: './search.page.html',
    styleUrls: ['./search.page.scss'],
})
export class SearchPage implements OnInit {
    public searchData = {'txt':''};
    public business;
    public items;

    //for item component:
    public cartOptions;
    public appuser;
    public ready;

    public searchText: string;
    public models: Array<MiniItem> = [];
    public options: object = {'search_auto_focus': false, 'hide_toolbar': false, 'hide_search':true};
    public filters: object = {'search':' '};

    footerOptions = {'hide-footer':false};

    public isweb = true;

    @ViewChild('searchbar') searchBar: IonSearchbar;
    @ViewChild('contentElement', {static: true}) contentElement: IonContent;

    constructor(public modelProvider: ModelProvider,
                public appDataService:AppDataService,
                public orderService:OrderService,
                public events: Events,
                public businessService: BusinessService) {
    }

    ionViewDidEnter() {
        setTimeout(() => {
            this.searchBar.setFocus();
        }, 150);
    }

    ngOnInit() {
        // this.options['hide_search'] = this.businessService.screenSize[0] < 1400
        this.events.subscribe('keyboard_click_itempref', (data)=>{
            if (data['fieldText']=='---')
            {

            }
        });

        // this.events.subscribe('keyboard_letter_itempref', (data) => {
        //     this.search(null, data['fieldText']);
        // })
        this.appuser = this.orderService.getAppUser();
        this.cartOptions = this.orderService.getCartOptions();
    }

    ngAfterViewInit() {
        let me = this;
        // setTimeout(function () {
            me.ready = true;
        // }, 1000);
    }

    ngOnDestroy() {
        this.events.unsubscribe('keyboard_click_itempref');
        this.events.unsubscribe('keyboard_letter_itempref')
    }

    // ionViewDidEnter() {
    //     // setTimeout(() => {
    //     //     this.searchbar.setFocus();
    //     // });
    //     // this.search('');
    // }
    isenter(event: any) {
        if (event && (event.code !== 'Enter' && event.keyCode !== 13)) {
            return
        }
        this.search(event, this.searchText, true);
    }

    search(event: any, searchText, force = false) {
        // if (event && event.target.value !== 'Enter' && !force && !this.isweb) {
        //     return
        // }

        if (!searchText || searchText == '') searchText = ' ';

        // if(searchText.length && searchText.length < 2) return;
        if(this.filters['search'] == searchText) return

        // this.modelProvider.list('miniItem', {'search':this.searchText}).then((res)=>{
        //   this.models = res['models'];
        // })
        this.filters['search'] = searchText
        this.events.publish(this.options['prefix'] + '_updateItems', this.filters);
        // this.events.publish(this.options['prefix'] + '_updateItemsFilter', filters);

        // let data = this.appDataService.searchItems('search', filters);
        // console.log(data);
        // this.items = data['models'];

        this.scrollToTop();
        //

    }

    scrollToTop() {
        this.contentElement.scrollToTop(500); // Adjust duration (ms) as needed
    }

}
